var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropzone mb-2",attrs:{"id":_vm.page}},[_c('canvas',{ref:"pdf",class:_vm.preview ? 'preview' : 'pdf'})])}
var staticRenderFns = []

export { render, staticRenderFns }